/**
 * English plural forms, chosen as WHOLE PHRASES.
 *
 * WHY THIS EXISTS (grader round 5, 8 September 2026). The notification bell
 * announced "Notifications, 1 item need you". The label was assembled as
 * `` `${n} item${n === 1 ? '' : 's'} need you` `` — the noun was pluralised by
 * appending a letter and the VERB beside it was not pluralised at all, so the
 * two never agreed at n = 1. Sticking a second conditional on the verb is the
 * same bug waiting for the next irregular word ("1 person is", "2 people are").
 *
 * So the caller writes both finished phrases and this picks one. `Intl.PluralRules`
 * makes the choice rather than an `=== 1`, which is the same answer in English
 * and the right seam if this product is ever read in another language.
 *
 * `{n}` in either phrase is replaced with the count.
 */

const EN_PLURAL_RULES = new Intl.PluralRules('en');

export function pluralPhrase(count: number, one: string, other: string): string {
  const form = EN_PLURAL_RULES.select(count) === 'one' ? one : other;
  return form.replace('{n}', String(count));
}
